import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';

import { Modal } from 'react-bootstrap'

import { httpOk, POST } from 'helpers/api'

const initData = {
    quantity: '',
    comment: '',
};

function UpdateProgress({ modal, setModal, item, getData }) {
    const { t } = useTranslation();

    const [sendData, setSendData] = useState({ ...initData })

    async function create() {
        var sendDataCopy = { ...sendData }
        delete sendDataCopy.unit_id;
        const response = await POST(`/production/orders/${item.id}/produce/`, sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData })
            getData();
        }
    }

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }


    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('update_progress')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('add_progress_info_desc')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('quantity')}</label>
                        <input type="text" placeholder='0' name="quantity"
                            value={sendData.quantity} onChange={(e) => handleChange(e)} />
                    </div>

                    <div className="form-group">
                        <label>{t('comment')}</label>
                        <input type="text" placeholder={t('comment')} name="comment"
                            value={sendData.comment} onChange={(e) => handleChange(e)} />
                    </div>

                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('save')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default UpdateProgress